import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { getAuthToken } from "../utils/authStorage";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { role, isAuthenticated } = useContext(AuthContext);
  const token = getAuthToken();
  const location = useLocation();

  if (!token || !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    let fallbackPath = "/home";
    if (role === "member") {
      fallbackPath = "/view_member";
    } else if (role === "hpc_admin") {
      fallbackPath = "/hpc/members";
    }
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
